<template>
  <main class="flex w-full">
    <section class="px-2 md:px-14 flex flex-col justify-start w-full">
      <form @submit.prevent="saveProfile()" class="bg-white p-5 md:p-8 rounded-md shadow-md">
        <div class="flex justify-between items-center md:items-start">
          <h6>
            {{
              $t("labels.generic", {
                pt: "Informações pessoais",
                en: "Personal Info",
              })
            }}
          </h6>
          <Button
            type="submit"
            label="Salvar"
            class="btn-primary p-button-sm"
            :loading="loading"
          />
        </div>
        <div
          class="flex flex-col md:flex-row my-4 w-full mt-6 space-y-8 md:space-y-0 md:space-x-4"
        >
          <span class="lg:w-9/12">
            <p class="mb-2">
              {{ $t("labels.generic", { pt: "Nome Completo", en: "Name" }) }}
            </p>
            <InputText id="name" type="text" v-model="user.name" />
            <Errors :errors="v$.user.name.$errors" />
          </span>
          <span class="lg:w-3/12">
            <p class="mb-2">
              {{
                $t("labels.generic", {
                  pt: "Data de Nascimento",
                  en: "Birthdate",
                })
              }}
            </p>
            <Calendar
              v-model="user.birthDate"
              class="w-full"
              dateFormat="dd/mm/yy"
              :manualInput="false"
            />
            <Errors :errors="v$.user.birthDate.$errors" />
          </span>
        </div>
      </form>
    </section>
  </main>
</template>

<script lang="ts">
import { or, required } from "@/locale/locale.config";
import { UsersRest } from "@/services/rest/users.rest";
import { Messages } from "@/utils/messages.util";
import { validateName } from "@/utils/regex.util";
import { ToastFactory } from "@/utils/toast-factory.util";
import useVuelidate from "@vuelidate/core";
import { delay } from "rxjs";
import { defineComponent } from "vue";
import { EditUserService } from "../edit-user.service";
export default defineComponent({
  name: "edit-profile",
  computed: {
    rest(): UsersRest {
      return new UsersRest();
    },
    service(): EditUserService {
      return new EditUserService();
    },
  },
  data() {
    return {
      loading: false as boolean,
    };
  },
  props: {
    user: {
      required: true,
      type: Object,
      default: new Object(),
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations() {
    return {
      user: {
        name: {
          required,
          validName: or((value: any) => {
            return validateName(value);
          }),
        },
        birthDate: { required },
      },
    };
  },
  methods: {
    saveProfile(): void {
      this.v$.user.$touch();
      if (!this.v$.user.$error) {
        this.loading = true;
        const data = {
          name: this.user.name,
          birthDate: this.user.birthDate,
        };

        this.rest
          .updateProfileUser(data)
          .pipe(delay(500))
          .subscribe({
            next: (response) => {
              this.loading = false;
              this.$toast.add(ToastFactory.success(Messages.USER_UPDATED));
              this.service.stockNewUser(response);
            },
            error: () => {
              this.loading = false;
            },
          });
      }
    },
  },
});
</script>
